<template>
  <div class="py-5" style="background-color: #adb4c3;" id="video-section" data-aos="fade-up">
    <div class="container text-center">
      <h2 class="mb-4 titulo-destacado" style="color: #1e3c63; font-style: bold;">DESCUBRE MÁS DE NOSOTROS</h2>
      <div class="ratio ratio-16x9 mx-auto" style="max-width: 800px;" >
        <div id="youtube-player"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoSection',
  mounted() {
    this.loadYouTubeAPI();
  },
  methods: {
    loadYouTubeAPI() {
      // Si ya está cargada
      if (window.YT && window.YT.Player) {
        this.initPlayer();
        return;
      }

      // Si no está cargada, creamos el script
      if (!document.getElementById('youtube-api')) {
        const tag = document.createElement('script');
        tag.id = 'youtube-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }

      // Función de callback global
      window.onYouTubeIframeAPIReady = () => {
        this.initPlayer();
      };
    },
    initPlayer() {
      if (window.YT && window.YT.Player) {
        try {
          new window.YT.Player('youtube-player', {
            height: '315',
            width: '560',
            videoId: 'GUQD08deVjQ',
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0
            }
          });
        } catch (error) {
          console.error('Error al inicializar YouTube Player:', error);
        }
      }
    }
  }
}
</script>

<style scoped>
.video-section {
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #adb4c3;
  overflow: hidden;
}

.titulo-destacado {
  margin-left: auto;
  margin-right: auto;
  color: #1e3c63;
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1.2;

  word-break: normal;
  overflow-wrap: normal;
}

.video-wrapper {
  width: 100%;
  max-width: 800px;
  overflow: hidden;
}

/* Ajusta el iframe que genera automáticamente YouTube */
.video-wrapper ::v-deep iframe {
  width: 100% !important;
  height: 100% !important;
  border: 0;
}

/* Tablets */
@media (max-width: 991.98px) {
  .titulo-destacado {
    font-size: 1.9rem;
  }

  .video-wrapper {
    max-width: 720px;
  }
}

/* Celulares */
@media (max-width: 767.98px) {
  .video-section {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
    padding-left: 12px;
    padding-right: 12px;
  }

  .titulo-destacado {
    margin-bottom: 24px !important;
    font-size: 1.6rem;
    line-height: 1.25;
  }

  .video-wrapper {
    max-width: 100%;
  }
}

/* Celulares pequeños */
@media (max-width: 479.98px) {
  .video-section {
    padding-top: 38px !important;
    padding-bottom: 38px !important;
    padding-left: 8px;
    padding-right: 8px;
  }

  .titulo-destacado {
    font-size: 1.4rem;
  }
}
</style>